import dayjs from 'dayjs';

import { roundScore } from '../../../helpers/ScoreHelper';
import { IProperty } from '../../../interfaces/Property';

import { CSV_DATE_FORMAT } from './SiteScanerTable.constants';

const escapeCsvField = (field: string | number): string => {
	if (field !== null && field !== undefined && field !== '') {
		return `${field}`.replace(/"/g, '""');
	}
	return '';
};

const getRowFromProperty = (property: IProperty): string[] => {
	const propertyName = escapeCsvField(property.name || '');
	const score = escapeCsvField(
		property.scoreResult?.score !== undefined ? roundScore(property.scoreResult.score) : ''
	);
	const scoreChange = escapeCsvField(property.scoreResult?.liftPercentage ?? '');
	const pages = escapeCsvField(property.lastUrlSet?.totalUrlsCount ?? '');
	const issues = escapeCsvField(property.lastScan?.issuesCount ?? '');
	const lastCrawl = escapeCsvField(
		property.lastUrlSet?.createdTime
			? dayjs(property.lastUrlSet.createdTime).format(CSV_DATE_FORMAT)
			: ''
	);
	const lastScan = escapeCsvField(
		property.lastScan?.createdTime
			? dayjs(property.lastScan.createdTime).format(CSV_DATE_FORMAT)
			: ''
	);

	return [propertyName, score, scoreChange, pages, issues, lastCrawl, lastScan];
};

export const getPropertiesCsvData = (properties: IProperty[]): string[][] => {
	if (!properties || properties.length === 0) {
		return [];
	}

	const sortedProperties = [...properties];
	sortedProperties.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
	return sortedProperties.map((property) => getRowFromProperty(property));
};
